function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgFormatTextColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "evenodd",
  d: "M1 15a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M3 12.002 7.607 1.556h.652L13 12.002M4.388 9.114h7.301"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 1,
  x2: 15,
  y1: 16.5,
  y2: 16.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA394B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#FFC604"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#56BCA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4177F6"
}))));
export default SvgFormatTextColor;